import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { faUsers, faChartLine, faIndustry, faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { trackCheckCtaClick } from "@/utils/analytics";

const CRITERIA_ICONS = [faUsers, faChartLine, faIndustry];

type Criterion = {
	value: string;
	label: string;
};

export default function LandingAffectedSection() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const ts = (key: string) => t(`questionnaire.landingAffected.${key}`);

	const criteria = t("questionnaire.landingAffected.criteria", {
		returnObjects: true,
	}) as Criterion[];

	const handleStartCheck = () => {
		trackCheckCtaClick("affected");
		navigate("/questionnaire/unknown");
	};

	return (
		<section className="w-full px-4 md:px-0">
			<div className="w-full max-w-[1420px] mx-auto py-16 sm:py-24 px-4 md:px-16 flex flex-col gap-12">
				<div className="flex flex-col items-center gap-4 text-center max-w-[820px] mx-auto">
					<span className="font-urbanist text-[13px] font-bold uppercase tracking-[0.12em] text-[#4680FC] bg-[#F0F4FF] border border-[#D8E4FF] rounded-full px-4 py-1.5">
						{ts("kicker")}
					</span>
					<h2 className="font-urbanist text-[34px] md:text-[40px] font-semibold leading-[120%] text-[#1D243C]">
						{ts("title")}
					</h2>
					<p className="font-urbanist text-[18px] font-normal leading-[150%] text-[#626373]">
						{ts("subtitle")}
					</p>
				</div>

				<div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
					{criteria?.map((item, index) => (
						<div
							key={item.label}
							className="flex flex-col items-center text-center gap-3 rounded-2xl border border-[#E6E6EC] bg-white p-8 shadow-[0_2px_10px_rgba(13,23,55,0.04)]"
						>
							<div className="flex w-14 h-14 shrink-0 rounded-2xl bg-[#F0F4FF] justify-center items-center">
								<Icon className="w-6 h-6 text-[#4680FC]" icon={CRITERIA_ICONS[index]} />
							</div>
							<span className="font-urbanist text-[30px] font-bold leading-[120%] text-[#1D243C]">
								{item.value}
							</span>
							<span className="font-urbanist text-[15px] leading-[150%] text-[#626373]">
								{item.label}
							</span>
						</div>
					))}
				</div>

				<p className="font-urbanist text-[15px] leading-[150%] text-[#626373] text-center max-w-[720px] mx-auto">
					{ts("note")}
				</p>

				<div className="flex flex-col items-center gap-5 rounded-2xl bg-[#F4F8FF] border border-[#E0EAFF] p-8 md:p-10 text-center">
					<p className="font-urbanist text-[22px] md:text-[26px] font-semibold leading-[130%] text-[#1D243C]">
						{ts("ctaTitle")}
					</p>
					<button
						className="flex items-center gap-2 px-10 py-3 rounded-xl bg-[#4680FC] hover:bg-[#336de0] transition-colors"
						type="button"
						onClick={handleStartCheck}
					>
						<span className="font-urbanist text-[16px] font-medium text-white">
							{ts("ctaButton")}
						</span>
						<Icon className="w-4 h-4 text-white" icon={faArrowRight} />
					</button>
				</div>
			</div>
		</section>
	);
}
